import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/store";

export type Audience = "users" | "departments" | "everyone";
export interface UserData {
  email: string;
  id: number;
}
interface DepartmentData {
  id: number;
  name: string;
}
export interface CourseSelected {
  id: number;
  name: string;
}
export type CourseSelectionMode = "all" | "select";

interface CertificateExport {
  selectedUsers: Array<UserData>;
  selectedDepartments: Array<DepartmentData>;
  targetedAudience: Audience;
  courseSelectionMode: CourseSelectionMode;
  selectedCourses: CourseSelected[];
}

const initialState: CertificateExport = {
  selectedUsers: [],
  selectedDepartments: [],
  targetedAudience: "everyone",
  courseSelectionMode: "all",
  selectedCourses: [],
};

const CertificateExportSlice = createSlice({
  name: "certificateExport",
  initialState,
  reducers: {
    setTargetedAudience: (state, action) => {
      state.targetedAudience = action.payload;
    },
    setSelectedDepartments: (state, action) => {
      state.selectedDepartments = action.payload;
    },
    setSelectedUsers: (state, action) => {
      state.selectedUsers = action.payload;
    },
    setCourseSelectionMode: (state, action) => {
      state.courseSelectionMode = action.payload;
    },
    setSelectedCourses: (state, action) => {
      state.selectedCourses = action.payload;
    },
  },
});

export const {
  setTargetedAudience,
  setSelectedDepartments,
  setSelectedUsers,
  setSelectedCourses,
  setCourseSelectionMode,
} = CertificateExportSlice.actions;

export const selectCertificateExport = (
  state: RootState,
): CertificateExport => {
  return state.certificateExport;
};

export default CertificateExportSlice.reducer;
